import { FormController } from './models';
import { noop } from '../../utils';

/**
 * Creates a form controller for the purpose of managing form validation and submission.
 *
 * @usage
 *   const formController = makeFormController({ ... });
 *   <form submit={formController.submit}>
 *     <TextInput {...inputProps} formController={formController} />
 *   </form
 *
 * @argument submit
 *   The action to perform on submission, e.g. calling an API.
 */
export function makeFormController(submitArg?: () => void): FormController {
  const submit = submitArg || noop;
  const validationHandlers: FormController['validationHandlers'] = {};
  const validate = () => {
    // Validate every field to trigger UI updates--don't short circuit.
    const validFields = Object.values(validationHandlers).map((handler) => handler());
    return validFields.every(Boolean);
  };
  const wrappedSubmit: FormController['submit'] = async (e) => {
    e.preventDefault();
    if (validate()) {
      submit();
    }
  };
  return { submit: wrappedSubmit, validationHandlers };
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/forms/utils.ts